import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';
import { ActivityInstructionsModalController } from './modal.controller';
import template from './modal.html';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export class ActivityInstructionsModal {
	public static readonly NG1_INJECTION_NAME = 'activityInstructionsModal' as const;

	/* @ngInject */
	constructor (private goModalBootstrap) {}

	public open (options) {
		options.template = template;
		options.controller = ActivityInstructionsModalController;
		options.windowClass = options.name = 'activity-instructions-modal';
		if (options.modalData?.embiggen) {
			options.windowClass += ' embiggen';
		}
		options.backdrop = 'static';
		options.controllerAs = '$ctrl';
		options.bindToController = true;
		options.goreact = true; // For new modal styles
		options.modalData = {
			...(options.modalData ?? {}),
			dialogTitleId: options.modalData?.dialogTitleId ?? `activity-instructions-title-${UniqueIdGeneratorUtil.getId()}`
		};
		return this.goModalBootstrap.open(options);
	}
}

export const activityInstructionsModalToken = upgradeNg1Dependency(ActivityInstructionsModal);
